import { Component } from "react";
import { Nav } from "react-bootstrap";
import ChevronListItem from "@/components/react/ChevronListItem";
import * as t from "@/lib/backend/manufacturing2.generated.types";

type Props = {
    filter: string;
    plantFilter: string;
    selected: t.IStockLocation | null;
    items: t.IStockLocation[];
    handleItemClick: (item: t.IStockLocation) => void;
};

class StockLocationsList extends Component<Props> {
    handleItemClick(item: t.IStockLocation) {
        // Ignore clicks for currently selected item.
        if (item === this.props.selected) {
            return;
        }

        // Handle parent's click events.
        this.props.handleItemClick(item);
    }

    includes(needle: string, item: t.IStockLocation): boolean {
        needle = needle.toLowerCase();
        if (needle.length === 0) return true;
        if (item.title.toLowerCase().indexOf(needle) > -1) return true;
        if (item.external_id.toLowerCase().indexOf(needle) > -1) return true;
        if (item.uuid.toLowerCase().indexOf(needle) > -1) return true;
        return false;
    }

    render() {
        const itemsList = this.props.items.map(item => {
            const is_active = this.props.selected === item;

            if (this.props.plantFilter && item.plant_uuid !== this.props.plantFilter) return null;
            if (!this.includes(this.props.filter, item)) return null;

            return (
                <ChevronListItem
                    key={item.uuid}
                    text={item.title}
                    subtext={item.external_id}
                    onClick={() => this.handleItemClick(item)}
                    is_active={is_active}
                />
            );
        });

        return (
            <Nav variant="tabs">
                <div className="nav-tabs-parent">{itemsList}</div>
            </Nav>
        );
    }
}

export default StockLocationsList;
